import React, { useMemo } from 'react';
import SparkleIcon from '../SparkleIcon';
import { useTheme } from '../../contexts/ThemeContext';

interface EmptyChatProps {
  userName: string;
  onSuggestionClick?: (suggestion: string) => void;
}

const EmptyChat: React.FC<EmptyChatProps> = ({ userName }) => {
  const { isDarkMode } = useTheme();
  
  // Randomized greetings
  const greeting = useMemo(() => {
    const greetings = [
      `Welcome back, ${userName}!`,
      `Good to see you, ${userName}!`,
      `Hey ${userName}, ready to learn?`,
      `Hello ${userName}!`,
      `Hi ${userName}, what's on your mind?`,
      `Welcome, ${userName}!`,
      `Hey there, ${userName}!`,
      `Good to have you back, ${userName}!`,
      `Nice to see you again, ${userName}!`,
      `Hello there, ${userName}!`,
      `Hey ${userName}, let's get started!`,
      `Welcome back, ${userName}!`,
      `Hi ${userName}, ready to explore?`,
      `Great to see you, ${userName}!`,
      `Hey ${userName}, what shall we learn today?`,
      `Welcome, ${userName}! Let's begin.`,
      `Hello ${userName}, how can I assist?`,
      `Hi there, ${userName}!`,
      `Welcome back, ${userName}! Ready to learn?`,
      `Hey ${userName}, what's new?`,
      `Good day, ${userName}!`,
      `Hello ${userName}, let's make progress!`,
      `Hi ${userName}, excited to help you learn!`,
      `Welcome, ${userName}! What interests you?`,
    ];
    
    return greetings[Math.floor(Math.random() * greetings.length)];
  }, [userName]);

  return (
    <div className={`empty-chat-container ${isDarkMode ? 'dark-theme' : 'light-theme'}`}>
      {/* Organic shape with varying edge lengths - Cyan color */}
      <div className="icon-wrapper">
        <SparkleIcon size={40} color="#06B6D4" />
      </div>

      {/* Greeting text */}
      <h1 className="greeting-text">{greeting}</h1>

      <style>{`
        .empty-chat-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          padding: 40px 20px;
          max-width: 600px;
          width: 100%;
          margin: 0 auto;
        }

        .icon-wrapper {
          margin-bottom: 32px;
        }

        .greeting-text {
          font-size: 32px;
          font-weight: 600;
          color: #FFFFFF;
          margin: 0 0 12px 0;
          letter-spacing: -0.02em;
        }

        .empty-chat-container.light-theme .greeting-text {
          color: #1F2937;
        }

        /* Mobile */
        @media (max-width: 640px) {
          .greeting-text {
            font-size: 28px;
          }
        }
      `}</style>
    </div>
  );
};

export default EmptyChat;
